export default __webpack_public_path__ + "static/GT-America-Standard-Medium-4c3d5f04c9fa152ef342d2e7144098e8.woff2";